(function(){
     'use strict';

     angular
        .module('appback')
        .factory('GenerallabService', GenerallabService);

    GenerallabService.$inject = ['$http'];

    function GenerallabService($http){

        var service = {
        	currentPeticion : false,
        	acciones : [],
        	topcomentarios: {},
        	interpretaciones: [],
        	num_chat:0,
        	num_cartas:0,
        	getValorNormalidadInfo : function(analitica){
	            var resultado = false;


	            var resultadoRestaSuma = 0;
	            if(analitica.resultado.signo){
	              //SI TIENE SIGNO LE RESTAMOS O SUMAMOS 1 PARA LAS INTERPRETACIONES Y VALORES DE NORMALIDAD
	                if(analitica.resultado.signo=="<"){
	                    resultadoRestaSuma = -0.01;
	                }else if(analitica.resultado.signo==">"){
	                    resultadoRestaSuma = 0.01;
	                }
	            }

	            if(typeof(analitica.valoresnormalidad)!='undefined'){
	              if(typeof(analitica.valoresnormalidad.interpretacion)!='undefined'){
	                for(var cont = 0;cont<analitica.valoresnormalidad.interpretacion.length && !resultado;cont++){
	                  if((typeof(analitica.valoresnormalidad.interpretacion[cont].slug)=='undefined' || !analitica.valoresnormalidad.interpretacion[cont].slug) && ((analitica.valoresnormalidad.interpretacion[cont].from=='' || (parseFloat(analitica.resultado.resultado)+resultadoRestaSuma)>=parseFloat(analitica.valoresnormalidad.interpretacion[cont].from)) && (analitica.valoresnormalidad.interpretacion[cont].to=='' || (parseFloat(analitica.resultado.resultado)+resultadoRestaSuma)<parseFloat(analitica.valoresnormalidad.interpretacion[cont].to)))){
	                    resultado = analitica.valoresnormalidad.interpretacion[cont];
	                  }
	                }
	              }else{
	                if(typeof(analitica.valoresnormalidad.valor)!='undefined'){
	                  var valorNormalidad = analitica.valoresnormalidad.valor.split("-");
	                  if((parseFloat(analitica.resultado.resultado)+resultadoRestaSuma)<parseFloat(valorNormalidad[0].replace(/,/g,'.').trim())){
	                        resultado = { interpretacion:'Bajo', icono : { fa_icon : 'arrow_downward' }, color:'#ff0000' };
	                  }else{
	                     if((parseFloat(analitica.resultado.resultado)+resultadoRestaSuma)>parseFloat(valorNormalidad[1].replace(/,/g,'.').trim())){
	                        resultado = { interpretacion:'Alto', icono : { fa_icon : 'arrow_upward' }, color:'#ff0000' };
	                     }
	                  }
	                }
	              }
	            }
	            //console.log("resultado "+analitica.analitica.nombre,resultado);
	            return resultado;
        	},
        	getValorNormalidad : function(analitica){
	            var resultado = false;


	            var resultadoRestaSuma = 0;
	            if(analitica.resultado.signo){
	              //SI TIENE SIGNO LE RESTAMOS O SUMAMOS 1 PARA LAS INTERPRETACIONES Y VALORES DE NORMALIDAD
	                if(analitica.resultado.signo=="<"){
	                    resultadoRestaSuma = -0.01;
	                }else if(analitica.resultado.signo==">"){
	                    resultadoRestaSuma = 0.01;
	                }
	            }

	            if(typeof(analitica.valoresnormalidad)!='undefined'){
	              if(typeof(analitica.valoresnormalidad.interpretacion)!='undefined'){
	                for(var cont = 0;cont<analitica.valoresnormalidad.interpretacion.length && !resultado;cont++){
	                  if(((analitica.valoresnormalidad.interpretacion[cont].from=='' || (parseFloat(analitica.resultado.resultado)+resultadoRestaSuma)>=parseFloat(analitica.valoresnormalidad.interpretacion[cont].from)) && (analitica.valoresnormalidad.interpretacion[cont].to=='' || (parseFloat(analitica.resultado.resultado)+resultadoRestaSuma)<parseFloat(analitica.valoresnormalidad.interpretacion[cont].to)))){
	                    resultado = analitica.valoresnormalidad.interpretacion[cont];
	                  }
	                }
	              }else{
	                if(typeof(analitica.valoresnormalidad.valor)!='undefined'){
	                  var valorNormalidad = analitica.valoresnormalidad.valor.split("-");
	                  if((parseFloat(analitica.resultado.resultado)+resultadoRestaSuma)<parseFloat(valorNormalidad[0].replace(/,/g,'.').trim())){
	                        resultado = { interpretacion:'Bajo', icono : { fa_icon : 'arrow_downward' }, color:'#ff0000' };
	                  }else{
	                     if((parseFloat(analitica.resultado.resultado)+resultadoRestaSuma)>parseFloat(valorNormalidad[1].replace(/,/g,'.').trim())){
	                        resultado = { interpretacion:'Alto', icono : { fa_icon : 'arrow_upward' }, color:'#ff0000' };
	                     }
	                  }
	                }
	              }
	            }
	            /*console.log("analitica",analitica.nombre);
	            console.log("analitica",analitica.resultado);
	            console.log("resultado",resultado);*/
	            //console.log("resultado "+analitica.analitica.nombre,resultado);
	            return resultado;
        	},
        	/*getValorNormalidadRangos : function(analitica){
	            var resultado = false;


	            var resultadoRestaSuma = 0;
	            if(analitica.resultado.signo){
	              //SI TIENE SIGNO LE RESTAMOS O SUMAMOS 1 PARA LAS INTERPRETACIONES Y VALORES DE NORMALIDAD
	                if(analitica.resultado.signo=="<"){
	                    resultadoRestaSuma = -1;
	                }else if(analitica.resultado.signo==">"){
	                    resultadoRestaSuma = 1;
	                }
	            }

	            if(typeof(analitica.valoresnormalidad)!='undefined'){
	              if(typeof(analitica.valoresnormalidad.interpretacion)!='undefined'){
	                for(var cont = 0;cont<analitica.valoresnormalidad.interpretacion.length && !resultado;cont++){
	                  if(!analitica.valoresnormalidad.interpretacion[cont].slug && ((analitica.valoresnormalidad.interpretacion[cont].from=='' || (parseFloat(analitica.resultado.resultado)+resultadoRestaSuma)>=parseFloat(analitica.valoresnormalidad.interpretacion[cont].from)) && (analitica.valoresnormalidad.interpretacion[cont].to=='' || (parseFloat(analitica.resultado.resultado)+resultadoRestaSuma)<parseFloat(analitica.valoresnormalidad.interpretacion[cont].to)))){
	                    resultado = analitica.valoresnormalidad.interpretacion[cont];
	                  }
	                }
	              }else{
	                if(typeof(analitica.valoresnormalidad.valor)!='undefined'){
	                  var valorNormalidad = analitica.valoresnormalidad.valor.split("-");
	                  if((parseFloat(analitica.resultado.resultado)+resultadoRestaSuma)<parseFloat(valorNormalidad[0].replace(/,/g,'.').trim())){
	                        resultado = { interpretacion:'Bajo', icono : { fa_icon : 'arrow_downward' }, color:'#ff0000' };
	                  }else{
	                     if((parseFloat(analitica.resultado.resultado)+resultadoRestaSuma)>parseFloat(valorNormalidad[1].replace(/,/g,'.').trim())){
	                        resultado = { interpretacion:'Alto', icono : { fa_icon : 'arrow_upward' }, color:'#ff0000' };
	                     }
	                  }
	                }
	              }
	            }
	            //console.log("resultado "+analitica.analitica.nombre,resultado);
	            return resultado;
        	},*/
        	comprobarCustoms:function(peticion, interpretacion){
        		if(interpretacion.valoresnormalidad.interpretacion){
	        		for(var cont=0;cont<interpretacion.valoresnormalidad.interpretacion.length;cont++){
	        			if(interpretacion.valoresnormalidad.interpretacion[cont].slug=="glucosa"){
	        				//COMPRUEBO PETICION
	        				if(peticion.tiposvalidados){
	        					var res = false;
	        					for(var cont2=0;cont2<peticion.tiposvalidados.length;cont2++){
	        						//COMPROBAMOS QUE tipomuestra: Suero CENTRIFUGADO o tubo glucosa, si no lo quitamos.
	        						//SUERO C SI
	        						//SUERO epp/C SI
	        						//TODO SUERO C SI
	        						//console.log(peticion.tiposvalidados[cont2].tipotubo_id);
	        						//console.log(peticion.tiposvalidados[cont2].tipomuestra_id);
	        						if((peticion.tiposvalidados[cont2].tipomuestra_id==39196/*SUERO*/ && (
	        							peticion.tiposvalidados[cont2].tipotubo_id==1380419 ||
	        							peticion.tiposvalidados[cont2].tipotubo_id==1238307 ||
	        							peticion.tiposvalidados[cont2].tipotubo_id==1091592 ||
	        							peticion.tiposvalidados[cont2].tipotubo_id==1087264 ||
	        							peticion.tiposvalidados[cont2].tipotubo_id==1087213 ||
	        							peticion.tiposvalidados[cont2].tipotubo_id==878815 ||
	        							peticion.tiposvalidados[cont2].tipotubo_id==878813 ||
	        							peticion.tiposvalidados[cont2].tipotubo_id==2237392 || 
	        							peticion.tiposvalidados[cont2].tipotubo_id==878812
	        							)) || peticion.tiposvalidados[cont2].tipomuestra_id==39251 || peticion.tiposvalidados[cont2].tipomuestra_id==39184 || peticion.tiposvalidados[cont2].tipomuestra_id==39186){
	        							res = true;
	        							//console.log("BORRAMOS");
	        						}
	        					}
	        					if(res){
	        						interpretacion.valoresnormalidad.interpretacion.splice(cont,1);
	        					}
	        					//console.log("FINALES",interpretacion);
	        				}
        					//console.log("compruebo peticion ",peticion);
	        			}
	        		}
	        	}
        		//COMPROBAMOS SI ES GLUCOSA Y MANUALMENTE
        		/*if(interpretacion.slug=="glucosa"){
        			console.log("GLUCOSA");
        		}*/
        		return interpretacion;
        	},
        	setInterpretaciones:function(peticion){
        		if(!angular.isDefined(this.interpretaciones)){
	        		this.interpretaciones = [];
	        		
	        	}

				for(var cont=0;cont<peticion.analiticas.length;cont++){


	                //var compCustom = this.comprobarCustoms(peticion, peticion.analitica.valoresnormalidad.interpretacion[cont]);

					//var interp = this.getValorNormalidad(peticion.analiticas[cont]);
					if(peticion.analiticas[cont].valoresnormalidad){
			            this.interpretaciones.push({
			            	peticion_id:peticion.id,
			            	categoria_id:peticion.analiticas[cont].analitica.categoriaanalitica_id,
			            	analitica : peticion.analiticas[cont],
			            	valoresnormalidad:peticion.analiticas[cont].valoresnormalidad
			            });
			        }
          		}
        	},
        	setInterpretacionesSubanalitica:function(item,subanalitica){
        		subanalitica.analitica = item.analitica;
        		//PARA IGUALAR EL OBJETO NORMAL
        			if(subanalitica.valoresnormalidad){
        				this.interpretaciones.push({
			            	peticion_id:item.peticion.id,
			            	categoria_id:item.analitica.categoriaanalitica_id,
			            	analitica : subanalitica,
			            	valoresnormalidad:subanalitica.valoresnormalidad
			            });
        			}

				/*for(var cont=0;cont<peticion.analiticas.length;cont++){
					console.log("an",peticion.analiticas[cont]);
					//var interp = this.getValorNormalidad(peticion.analiticas[cont]);
					if(peticion.analiticas[cont].valoresnormalidad){
			            this.interpretaciones.push({
			            	peticion_id:peticion.id,
			            	categoria_id:peticion.analiticas[cont].analitica.categoriaanalitica_id,
			            	analitica : peticion.analiticas[cont],
			            	valoresnormalidad:peticion.analiticas[cont].valoresnormalidad
			            });
			        }
          		}
          		console.log("inter",this.interpretaciones);*/
        	},
        	getInterpretacionesCategoriaRep : function(peticion,categoria){
        		this.getInterpretacionesCategoria(peticion,categoria);
        		return peticion.comentarios_json['auto'][categoria.id];
        	},
        	addComentarioAutomatico(categoria,analitica,peticion){
        		if(!angular.isDefined(peticion.comentarios_json['auto'])){
	        		peticion.comentarios_json['auto'] = {};
	        	}
        		if(!angular.isDefined(peticion.comentarios_json['auto'][categoria.id])){
	        		peticion.comentarios_json['auto'][categoria.id] = [];
	        	}
        		var valorNormalidad = this.getValorNormalidad(analitica);
        		var res = false;

    				if(valorNormalidad){
    					//console.log("cat",categoria);
    					//console.log("an",analitica);
    					//console.log("valNorm",valorNormalidad);
  						for(var cont=0;cont<peticion.comentarios_json['auto'][categoria.id].length && !res;cont++){
  							if(peticion.comentarios_json['auto'][categoria.id][cont].interpretacion_id==valorNormalidad.id){
  								res = cont;
  							}
  						}
    					//console.log(valorNormalidad);
   						if(valorNormalidad.comentario){
	    					if(res===false ){
	    						console.log("analitica",analitica);
	    						console.log("valorNormalidad",valorNormalidad);
	    						console.log("comentario",{ categoria_id:categoria.id,analitica: {id:analitica.analitica.id,nombre:analitica.analitica.nombre,nombre_order:analitica.nombre}, comentario: valorNormalidad.comentario, interpretacion_id:valorNormalidad.id, checked:1 });
		    					peticion.comentarios_json['auto'][categoria.id].push({ categoria_id:categoria.id,analitica: {id:analitica.analitica.id,nombre:analitica.analitica.nombre,nombre_order:analitica.nombre}, comentario: valorNormalidad.comentario, interpretacion_id:valorNormalidad.id, checked:1 });
	    					}else{
	    						peticion.comentarios_json['auto'][categoria.id][res].comentario = valorNormalidad.comentario;
	    					}
	    					return valorNormalidad.id;
	    				}
    				}
    				return false
        	},
        	getInterpretacionesCategoria : function(peticion,categoria,borrar){
        		
        		
        		var interVal = [];
        		var idsValores = [];

        		for(var cont=0;cont<this.interpretaciones.length;cont++){
        			this.interpretaciones[cont] = this.comprobarCustoms(peticion,this.interpretaciones[cont]);
        			if(this.interpretaciones[cont].categoria_id==categoria.id && this.interpretaciones[cont].peticion_id==peticion.id){
        				interVal.push(this.interpretaciones[cont]);
        				idsValores.push(this.addComentarioAutomatico(categoria,this.interpretaciones[cont].analitica,peticion));
        				//NO SE USA YA
        			}
        		}
        		if(angular.isDefined(borrar)){
	        		if(angular.isDefined(peticion.comentarios_json['auto']) && angular.isDefined(peticion.comentarios_json['auto'][categoria.id])){
		        		for (var i = peticion.comentarios_json['auto'][categoria.id].length - 1; i >= 0; i--) {
							if (!idsValores.includes(peticion.comentarios_json['auto'][categoria.id][i].interpretacion_id)) {
						    	//console.log("BORRAMOS");
						        peticion.comentarios_json['auto'][categoria.id].splice(i, 1);
							}
						}
					}
				}

        		
        		//console.log("inter",this.interpretaciones);
        		//console.log("json",peticion.comentarios_json['auto']);

        		return interVal;
        	},
            optionsEspecies : {
            	//data:[{id: "0003", text: "1"}],
	            ajax: {
	                headers: { 'Content-Type': 'application/json' },
	                url: "/backend/peticion/getespecies",
	                dataType: 'json',
	                delay: 250,
	                data: function (params) {
	                    return {
	                      q: params.term, // search term
	                      page: params.page,
	                      lang_id: lang_id,
	                      per_page: 20
	                    };
	                },
	                processResults: function (data, params) {
	                    // parse the results into the format expected by Select2
	                    // since we are using custom formatting functions we do not need to
	                    // alter the remote JSON data, except to indicate that infinite
	                    // scrolling can be used
	                    params.page = params.page || 1;
	                    return {
	                      results: data.items,
	                      pagination: {
	                        more: (params.page * 1) < data.total_count
	                      }
	                    };
	                }
	                
	            },
	            
	        },
	        optionsSelect2 : { 
        		ajax: {
                    url: "/backend/altcrm/content/select2",
                    dataType: 'json',
                    delay: 250,
                    data: function (params) {
                      return {
                        q: params.term, // search term
                        page: params.page,
                        field: 'nombre',
                        per_page: 20,
                        //nodetype:'microorganismo'
                      };
                    },
                    processResults: function (data, params) {
                      params.page = params.page || 1;
                      return {
                        results: data.items,
                        pagination: {
                          more: (params.page * 1) < data.total_count
                        }
                      };
                    },
                    cache: true
                }
        	},
        	optionsAtributos : {
        		ajax: {
                    url: "/backend/resultadopeticion/select2atributos",
                    dataType: 'json',
                    delay: 250,
                    data: function (params) {
                      return {
                        q: params.term, // search term
                        page: params.page,
                        field: 'nombre',
                        per_page: 20,
                        nodetype:'valoresatt'
                      };
                    },
                    processResults: function (data, params) {
                      params.page = params.page || 1;
                      return {
                        results: data.items,
                        pagination: {
                          more: (params.page * 1) < data.total_count
                        }
                      };
                    },
                    cache: true
                }
        	},
	        optionsVet: {
	        	//data:[{id: "0003", text: "1"}],
	            ajax: {
	                headers: { 'Content-Type': 'application/json' },
	                url: "/backend/peticion/getveterinarios",
	                dataType: 'json',
	                delay: 250,
	                data: function (params) {
	                    return {
	                      q: params.term, // search term
	                      page: params.page,
	                      lang_id: lang_id,
	                      per_page: 20
	                    };
	                },
	                processResults: function (data, params) {
	                    // parse the results into the format expected by Select2
	                    // since we are using custom formatting functions we do not need to
	                    // alter the remote JSON data, except to indicate that infinite
	                    // scrolling can be used
	                    params.page = params.page || 1;
	                    return {
	                      results: data.items,
	                      pagination: {
	                        more: (params.page * 1) < data.total_count
	                      }
	                    };
	                }
	                
	            },
	        },
	        optionsRaces : {
	            ajax: {
	                headers: { 'Content-Type': 'application/json' },
	                url: "/backend/peticion/getraces",
	                dataType: 'json',
	                delay: 250,
	                data: function (params) {
	                    return {
	                      q: params.term, // search term
	                      page: params.page,
	                      lang_id: lang_id,
	                      //especieseleccionada: vm.newAnimal.especie,//SELECCIONAR EN CADA CONTROLLER
	                      per_page: 20
	                    };
	                },
	                processResults: function (data, params) {
	                    // parse the results into the format expected by Select2
	                    // since we are using custom formatting functions we do not need to
	                    // alter the remote JSON data, except to indicate that infinite
	                    // scrolling can be used
	                    params.page = params.page || 1;
	                    return {
	                      results: data.items,
	                      pagination: {
	                        more: (params.page * 1) < data.total_count
	                      }
	                    };
	                }
	            }
	        },
	        optionsIdiomas : {
	            ajax: {
	                headers: { 'Content-Type': 'application/json' },
	                url: "/backend/peticion/getidiomas",
	                dataType: 'json',
	                delay: 250,
	                data: function (params) {
	                    return {
	                      q: params.term, // search term
	                      page: params.page,
	                      lang_id: lang_id,
	                      //especieseleccionada: vm.newAnimal.especie,//SELECCIONAR EN CADA CONTROLLER
	                      per_page: 20
	                    };
	                },
	                processResults: function (data, params) {
	                    // parse the results into the format expected by Select2
	                    // since we are using custom formatting functions we do not need to
	                    // alter the remote JSON data, except to indicate that infinite
	                    // scrolling can be used
	                    params.page = params.page || 1;
	                    return {
	                      results: data.items,
	                      pagination: {
	                        more: (params.page * 1) < data.total_count
	                      }
	                    };
	                }
	            }
	        },
	        optionsProvincias: {
	        	ajax: {
	                headers: { 'Content-Type': 'application/json' },
	                url: "/backend/peticion/getprovincias",
	                dataType: 'json',
	                delay: 250,
	                data: function (params) {
	                    return {
	                      q: params.term, // search term
	                      page: params.page,
	                      per_page: 20
	                    };
	                },
	                processResults: function (data, params) {
	                    // parse the results into the format expected by Select2
	                    // since we are using custom formatting functions we do not need to
	                    // alter the remote JSON data, except to indicate that infinite
	                    // scrolling can be used
	                    params.page = params.page || 1;
	                    return {
	                      results: data.items,
	                      pagination: {
	                        more: (params.page * 1) < data.total_count
	                      }
	                    };
	                }
	            }
	        },
	        optionsMunicipis: {
	        	ajax: {
	                headers: { 'Content-Type': 'application/json' },
	                url: "/backend/peticion/getmunicipis",
	                dataType: 'json',
	                delay: 250,
	                data: function (params) {
	                    return {
	                      q: params.term, // search term
	                      page: params.page,
	                      //provincia: vm.provincia,//SELECCIONAR EN CADA CONTROLLER
	                      per_page: 20
	                    };
	                },
	                processResults: function (data, params) {
	                    // parse the results into the format expected by Select2
	                    // since we are using custom formatting functions we do not need to
	                    // alter the remote JSON data, except to indicate that infinite
	                    // scrolling can be used
	                    params.page = params.page || 1;
	                    return {
	                      results: data.items,
	                      pagination: {
	                        more: (params.page * 1) < data.total_count
	                      }
	                    };
	                }
	            }
	        },
	        optionsSexo : {
	            ajax: {
	                headers: { 'Content-Type': 'application/json' },
	                url: "/backend/peticion/getsexos",
	                dataType: 'json',
	                delay: 250,
	                data: function (params) {
	                    return {
	                      q: params.term, // search term
	                      page: params.page,
	                      lang_id: lang_id,
	                      //especieseleccionada: vm.newAnimal.especie,//SELECCIONAR EN CADA CONTROLLER
	                      per_page: 20
	                    };
	                },
	                processResults: function (data, params) {
	                    // parse the results into the format expected by Select2
	                    // since we are using custom formatting functions we do not need to
	                    // alter the remote JSON data, except to indicate that infinite
	                    // scrolling can be used
	                    params.page = params.page || 1;
	                    return {
	                      results: data.items,
	                      pagination: {
	                        more: (params.page * 1) < data.total_count
	                      }
	                    };
	                }
	            }
	        },
	        optionsEstado : {
	            ajax: {
	                headers: { 'Content-Type': 'application/json' },
	                url: "/backend/peticion/getestados",
	                dataType: 'json',
	                delay: 250,
	                data: function (params) {
	                    return {
	                      q: params.term, // search term
	                      page: params.page,
	                      lang_id: lang_id,
	                      //especieseleccionada: vm.newAnimal.especie,//SELECCIONAR EN CADA CONTROLLER
	                      per_page: 20
	                    };
	                },
	                processResults: function (data, params) {
	                    // parse the results into the format expected by Select2
	                    // since we are using custom formatting functions we do not need to
	                    // alter the remote JSON data, except to indicate that infinite
	                    // scrolling can be used
	                    params.page = params.page || 1;
	                    return {
	                      results: data.items,
	                      pagination: {
	                        more: (params.page * 1) < data.total_count
	                      }
	                    };
	                }
	            }
	        },
	        optionsCentros : {
	            ajax: {
	                headers: { 'Content-Type': 'application/json' },
	                url: "/backend/peticion/getcentros",
	                dataType: 'json',
	                delay: 250,
	                data: function (params) {
	                    return {
	                      q: params.term, // search term
	                      page: params.page,
	                      lang_id: lang_id,
	                      //especieseleccionada: vm.newAnimal.especie,//SELECCIONAR EN CADA CONTROLLER
	                      per_page: 20
	                    };
	                },
	                processResults: function (data, params) {
	                    // parse the results into the format expected by Select2
	                    // since we are using custom formatting functions we do not need to
	                    // alter the remote JSON data, except to indicate that infinite
	                    // scrolling can be used
	                    params.page = params.page || 1;
	                    return {
	                      results: data.items,
	                      pagination: {
	                        more: (params.page * 1) < data.total_count
	                      }
	                    };
	                }
	            }
	        },
	        optionsSinglePicker : {
	            singleDatePicker: true,
	            maxDate : moment(),
	            showDropdowns: true,
	            //timezone:'CET',
	            opens:'center',
	            alwaysShowCalendars: true,
	            showCustomRangeLabel: false,
	            locale: {
	                applyLabel: "Aplicar",
	                cancelLabel: 'Cancelar',
	                clearLabel: 'Limpiar',
	                separator: ' - ',
	                format: "DD-MM-YYYY",
	                daysOfWeek: ['Dm', 'Ln', 'Mr', 'Mi', 'Jv', 'Vi', 'Sa'],
                    monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
                    firstDay: 1
	            },
	            ranges: {
	                'Hoy': [moment(), moment()],
	                'Ayer': [moment().subtract(1, 'day'), moment().subtract(1, 'day')],
	                'Últimos 7 días': [moment().subtract(6, 'days'), moment()],
	                'Últimos 30 días': [moment().subtract(29, 'days'), moment()],
	                'Mes actual': [moment().startOf('month'), moment().endOf('month')],
	                'Mes anterior': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
	            }
	        },
	        optionsMultiplePicker : {
	            maxDate : moment(),
	            opens:'center',
	            alwaysShowCalendars: true,
	            showCustomRangeLabel: false,
	            locale: {
	                applyLabel: "Aplicar",
	                cancelLabel: 'Cancelar',
	                clearLabel: 'Limpiar',
	                separator: ' - ',
	                format: "DD-MM-YYYY",
	            },
	            ranges: {
	                'Hoy': [moment(), moment()],
	                'Ayer': [moment().subtract(1, 'day'), moment().subtract(1, 'day')],
	                'Últimos 7 días': [moment().subtract(6, 'days'), moment()],
	                'Últimos 30 días': [moment().subtract(29, 'days'), moment()],
	                'Mes actual': [moment().startOf('month'), moment().endOf('month')],
	                'Mes anterior': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
	            },
	            /*changeCallback: function(){
	                $timeout(function(){
	                    vm.init();
	                });
	            },*/
	            /*eventHandlers: {
	                'apply.daterangepicker': function(event, picker) { $timeout(function(){
	                    vm.init();
	                }); },
	                'cancel.daterangepicker': function(event, picker) { $timeout(function(){
	                    vm.init();
	                }); }
	            },
	            cancelOnOutsideClick:true*/
	        }
        };

        return service;
 		

    }
})();